import { Component, OnInit } from '@angular/core';
import { ExpenseService } from 'src/app/services/expense.service';
import { Expense } from 'src/app/models/expense';
import { AuthService } from 'src/app/services/auth.service';
import { ExpenseType } from 'src/app/models/expense-type';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ToastrManager } from 'ng6-toastr-notifications';

export interface Axis {
  axis:number,
  price:number,
}

@Component({
  selector: 'app-expense',
  templateUrl: './expense.component.html',
  styleUrls: ['./expense.component.css']
})
export class ExpenseComponent implements OnInit {
  expenses:Expense[] = [];
  expenseClones:Expense[];
  expense:Expense = {
    expense_type: {
      id: 0,
      name: '',
      type: '',
      active: true,
      et_type_id: 0,
      et_type_name: '',
      apply_unit: true
    },
    expense_type_id: 0,
    id: 0,
    name: '',
    price: 0,
    active: true,
    axis: []
  };
  expenseTypes:ExpenseType[] = [];

  actAddExp:boolean = true;
  actEditExp:boolean = true;
  actDeleteExp:boolean = true;
  loading: boolean = false;
  expand:boolean = false;

  filter:{name:string, type:number} = {
    name: '',
    type: 0,
  };

  axis:Axis = {
    axis: 0,
    price: 0,
  };

  //Pagination
  public page:number = 1;
  public pagination:number = 20;

  constructor(private expenseServ:ExpenseService, private auth:AuthService, private modalService: NgbModal, private utl:UtilitiesService, private toastr: ToastrManager) { }

  async ngOnInit() {
    this.loading = true;
    this.actAddExp = this.auth.can("store-expense");
    this.actEditExp = this.auth.can("update-expense");
    this.actDeleteExp = this.auth.can("destroy-expense");
    this.getExpenses();
    this.expenseTypes = (await this.expenseServ.getExpenseTypes()).filter(exp => exp.type != 'Mantenimiento');
    this.loading = false;
  }

  select(modal?, expense?:Expense) {
    if(expense) {
      this.expense = expense;
      this.expense.expense_type = this.expenseTypes.find(x => x.id == this.expense.expense_type_id);
    } else {
      this.expense = {
        expense_type: this.expenseTypes[0],
        expense_type_id: this.expenseTypes[0].id,
        id: 0,
        name: '',
        price: 0,
        active: true,
        axis: [],
      };
    }

    this.axis = {
      axis: 0,
      price: 0,
    };

    if(modal) {
      this.modalService.open(modal, { size: 'lg', windowClass: 'bigger' });
    }
  }

  addAxis() {
    if(this.axis.axis && this.axis.price) {
      //search if exists
      let data = this.expense.axis.find(x => x.axis == this.axis.axis);
      if(data) {
          data.axis = this.axis.axis;
          data.price = this.axis.price;
      } else {
        this.expense.axis.push({
          axis: this.axis.axis,
          price: this.axis.price,
        });
      }
    } else {
      this.toastr.infoToastr('Ambos campos son obligatorios y diferentes de cero', '', {enableHTML: true});
    }
  }

  async getExpenses(clear:boolean = true) {
    if(clear) {
      this.expenses = await this.expenseServ.getExpenses();
      this.expenseClones = JSON.parse(JSON.stringify(this.expenses))
    } else {
      this.expenses = JSON.parse(JSON.stringify(this.expenseClones))
    }
  }

  async updateExpense() {
    try {
      this.loading = true;
      this.expense.expense_type_id = this.expense.expense_type.id;
      await this.expenseServ.putExpense(this.expense);
      await this.getExpenses();
      this.clearFilterData();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El gasto se ha actualizado correctamente', '', {enableHTML: true});
    } catch (e) {
      this.toastr.errorToastr(this.utl.formatMessages(e), '', {enableHTML: true});
      this.loading = false;
    }
  }

  async storeExpense() {
    try {
      this.loading = true;
      this.expense.expense_type_id = this.expense.expense_type.id;
      await this.expenseServ.postExpense(this.expense);
      await this.getExpenses();
      this.clearFilterData();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El gasto se ha agregado correctamente', '', {enableHTML: true});
    } catch (e) {
      this.toastr.errorToastr(this.utl.formatMessages(e), '', {enableHTML: true});
      this.loading = false;
    }
  }

  async deleteExpense() {
    try {
      this.loading = true;
      await this.expenseServ.deleteExpense(this.expense);
      await this.getExpenses();
      this.clearFilterData();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El gasto se ha eliminado correctamente', '', {enableHTML: true});
    } catch (e) {
      this.toastr.errorToastr(this.utl.formatMessages(e), '', {enableHTML: true});
      this.loading = false;
    }
  }

  async filterData() {
    this.loading = true;
    this.getExpenses(false);

    if(this.filter.type != 0) {
      this.expenses = this.expenses.filter(x => x.expense_type_id == this.filter.type);
    }

    if(this.filter.name) {
      let name = this.filter.name.toLowerCase();
      let tmp:Expense[] = [];

      for(let expense of this.expenses) {
        let nombre:string = expense.name.toLowerCase();

        if(nombre.indexOf(name) >= 0) {
          tmp.push(expense);
        }
      }

      this.expenses = tmp;
    }

    this.loading = false;
  }

  clearFilterData(filter:boolean = false) {
    this.filter = {
      name: '',
      type: 0,
    };
    if(filter) {
      this.filterData();
    }
  }
}
